import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Avatar, Button, Chip } from "@mui/material";
import BASE_API_URL from '../../apis/index';
import { IoIosArrowForward } from "react-icons/io";
import { UserContext } from "../../App";

export default function AdminLayout() {
  const {user} = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.role !== "admin") {
      // redirect non-admins to dashboard or login
      navigate("/dashboard");
    }
  }, [user, navigate]);

  // Handle Logout
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    navigate('/');
  };

  // prevent rendering if not admin
  if (!user || user.role !== "admin") return null;

  return (
    <Wrapper>
      <div className="dashboard">
        <div className="leftBox d-flex flex-column justify-content-between">
          <div>
            <Link to='/admin/dashboard'>
              <img
                src="/Images/nt-logo-white.png"
                width={"85px"}
                alt="logo"
                className="mb-3"
              />
            </Link>

            <div className="d-flex flex-column gap-3 border-top pt-3">
              <Link to="/admin/companies">User Companies</Link>
              <Link to="/admin/users">Vendors/Users</Link>
            </div>
          </div>

          <div>
            <div className="userProfile d-flex align-items-start flex-column gap-2">
              <Link className="mb-2 d-flex align-items-center justify-content-between gap-2 bg_primary_color p-2 rounded-2 w-100" to="/dashboard">User Dashboard <IoIosArrowForward /> </Link>
              <Link to={'/profile'} className="text-decoration-none w-100">
                <Chip
                  avatar={<Avatar alt={user.name} src={`${BASE_API_URL}/uploads/user_profile_images/${user.profile_image}`} />}
                  label={<span className="text-white"> {user.name} </span>}
                  variant="outlined"
                  size="large"
                  className="w-100 rounded-3 justify-content-start"
                />
              </Link>
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={handleLogout}
                sx={{
                  color: 'white',
                  borderColor: 'white',
                  '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              >
                Logout
              </Button>
            </div>
          </div>
        </div>
        <div className="rightBox bg-white">
          <Outlet />
        </div>
      </div>
    </Wrapper>
  );
}


const Wrapper = styled.div`
  padding: 10px;
  min-height: 100vh;
  .dashboard {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  .leftBox {
    width: 18%;
    background-color: black;
    position: sticky;
    top: 10px;
    height: 98vh;
    border-radius: 15px;
    padding: 50px;
    align-items: space-between;
    .userProfile {
      align-items: center;
      .userName{
        font-size: 16px;
      }
      img {
        border-radius: 50px;
        width: 60px;
        height: 60px;
      }
    }
    a {
      text-decoration: none;
      color: var(--white-color);
      svg path{ fill: white; }
      &:hover {
        color: var(--secondary-color);
        svg path{ fill: var(--secondary-color); }
      }
    }

    .txtBtm {
      margin-top: 100px;
      h5 {
        color: var(--white-color);
        &:hover {
          color: var(--secondary-color);
        }
      }
    }
  }
  .rightBox {
    width: 82%;
    padding: 10px 10px 10px 35px;
    border-radius: 15px;
    h2 {
      color: var(--primary-color);
    }
  }
`;
